import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Pipe({
  name: 'pluck'
})
export class PluckPipe implements PipeTransform {

  transform<T>(obs$: Observable<T>, ...props: string[]): Observable<string> {
    // @ts-ignore
    return obs$.pipe(
      pluck(...props),
    );
  }

}
